import React, { Component } from 'react'
import { connect } from 'react-redux'
import ButtonWithoutLoader from 'UI/ButtonWithoutLoader'

import { ExcelUploadColumns } from 'Constants'
import {uploadUserDefinedFields,insertReportLogDetails} from 'actions/spendActions'

import * as FileSaver from "file-saver";
import * as XLSX from 'xlsx';
import { Workbook } from 'exceljs/dist/exceljs';
import classNames from "classnames";
import { path } from 'Constants'


const recommendationData= ['Already Transacting', 'Relationship Exists', 'Enterprise - Supplier Dedicated Specialist (Integration & Catalog)', "Enterprise - Integration & Catalog", "Enterprise - Integration",  "Enterprise - Portal & Catalog", 'Enterprise - Portal', 'Managed Standard Account', 'On Going Standard Account', 'Out of Scope']

const instructions=[
'1. Download the excel upload template.',
'2. Make edits or add data in excel for the desired suppliers.',
'3. Choose your file and upload the updated template.'
]

const notes=['- Upload template excel sheet contain editable(orange) columns and non-editable(blue) columns.',
  '- Validation on editable columns ensure data quality.  Your file will error if the data is not in the format expected.',
  '- Non-editable columns will not be uploaded and are for reference only',
  '- Buyer Supplier Enablement Recommendation column only allows input from dropdown selection',
  '- Enablement Wave column only allows input from dropdown selection',
  '- Buyer Supplier Relationship column allows input text length up to 50 characters',
  '- User Defined Text Field Columns allows input text length up to 128 characters',
  '- User Defined Number Field Columns allows only numbers'
  ]

class UploadAddressableSpend extends Component{
  constructor(props)
  {
  super(props)
  this.state={
    csvFile: '',
    columns: [],
    data: [],
    responseMsg: '',
    excelData: [],
    isSaveInProgress: false,
    fileValidationFailed: false
  }

  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.isLoading !== this.state.isLoading ||
      prevState.isSaveInProgress !== this.state.isSaveInProgress
    ) {
      const isBlocking = this.state.isLoading || this.state.isSaveInProgress;
  
      if (this.props.setBlocking) {
        this.props.setBlocking(isBlocking);
      }
    }
  }

  insertReportAudit(logType,fileName) {
    let dmcId = this.props.spendDetails.currentActiveRequest.DMC_ID;
    let vsId = this.props.spendDetails.currentActiveRequest.VS_ID;
    let user = this.props.user.user.Email;
    this.props.insertReportLogDetails(dmcId, vsId, user,logType,fileName)
        .then((response) => {
            this.setState({ isLoading: false });
        }).catch((error) => {
            if (error.stack.includes('Network Error')) {
                this.setState({ responseMsg: 'API service is down. Please contact administrator.', isError: 'Yes', isLoading: false })
            }
            else {
                this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false })
            }
        })
}

  handleChange(e){
    const files = e.target.files;
        if (files && files[0]) this.setState({ file: files[0], responseMsg: '', isError: 'No', isLoading: false, isSaveInProgress: false }, this.handleFile);        
  }

  handleFile() {

    this.setState({ responseMsg: "" });

    const reader = new FileReader();

    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {

        const wb = XLSX.read(
            e.target.result,
            {
                type: rABS ? 'binary' : 'array'
            }
        );

        const ws =
            wb.Sheets[wb.SheetNames[0]];

        const data =
            XLSX.utils.sheet_to_json(
                ws,
                { defval: "" }
            );

        let errors = [];

        const hasAtLeastOneYes = data.some(
          row =>
              String(row["Addressable Spend"])
                  .trim()
                  .toLowerCase() === 'yes'
      );
      
      if (!hasAtLeastOneYes) {
      
          this.setState({
              excelData: [],
              responseMsg:
                  'Upload file must contain at least one Addressable Spend value as Yes.',
              isError: 'Yes'
          });
      
          document.getElementById('csvFile').value = null;
      
          return;
      }

        data.forEach((item, index) => {

            const rowNo = index + 2;

            const value =
                String(
                    item["Addressable Spend"] || ""
                ).trim();

            if (
                value !== "Yes" &&
                value !== "No"
            ) {

                errors.push(
                    `Row ${rowNo}: ADDRESSABLE SPEND must be Yes or No`
                );
            }
        });

        if (errors.length > 0) {

          console.log(
              'Validation Failed'
          );
      
          console.log(errors);
      
          this.setState({
              excelData: [],
              fileValidationFailed: true,
              responseMsg: errors.join("\n"),
              isError: 'Yes'
          });
      
          return;
      }

        this.setState({
          excelData: data,
          fileValidationFailed: false,
          isError: 'No'
      }, () => {
      
          console.log(
              'Excel Loaded Successfully',
              this.state.excelData.length
          );
      
          console.log(
              'First Row',
              this.state.excelData[0]
          );
      });
    };

    if (rABS)
        reader.readAsBinaryString(this.state.file);
    else
        reader.readAsArrayBuffer(this.state.file);
}

initializeColumns() {

  const columns = [];

  columns.push({
      header: "Addressable Spend",
      key: "ADDRESSABLE_SPEND",
      width: 20,
      editable: true
  });

  this.props.columnDefs.forEach(col => {

      if (
          !col.key ||
          col.key === "ADDRESSABLE_SPEND"
      ) {
          return;
      }

      columns.push({
          header: col.name,   // Screen Field Name
          key: col.key,       // Database Field
          width: 25,
          editable: false
      });
  });

  return columns;
}

handleDownload() {

  this.setState(
      { isSaveInProgress: true },
      this.downloadAddressableSpendTemplate
  );
}

downloadAddressableSpendTemplate() {

  this.setState({ responseMsg: "" });

  let workbook = new Workbook();

  let worksheet =
      workbook.addWorksheet("Addressable Spend Upload");

  const columnDetails = this.initializeColumns();

  worksheet.columns = columnDetails;

  worksheet.getRow(1).eachCell((cell) => {

    cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '007ad9' }
    };

    cell.font = {
        color: { argb: 'FFFFFF' }
    };
});

worksheet.getCell('A1').fill = {
  type: 'pattern',
  pattern: 'solid',
  fgColor: { argb: 'ff8c00' }
};

worksheet.getCell('A1').font = {
  color: { argb: 'FFFFFF' }
};

this.props.rowData.forEach(row => {

  const excelRow = {};

  columnDetails.forEach(col => {

      if (col.key === 'VS_ID') {

          excelRow[col.key] =
              this.props.spendDetails.currentActiveRequest.VS_ID;
      }
      else if (col.key === 'DMC_ID') {

          excelRow[col.key] =
              this.props.spendDetails.currentActiveRequest.DMC_ID;
      }
      else {

          excelRow[col.key] =
              row[col.key] == null
                  ? ''
                  : row[col.key];
      }

  });

  worksheet.addRow(excelRow);

});

  const addressableColumn =
      worksheet.getColumn('ADDRESSABLE_SPEND');

  addressableColumn.eachCell((cell, rowNumber) => {

      if (rowNumber === 1)
          return;

      cell.dataValidation = {
          type: 'list',
          allowBlank: false,
          formulae: ['"Yes,No"'],
          showErrorMessage: true,
          errorStyle: 'error',
          errorTitle: 'Selection Required',
          error: 'Please select Yes or No'
      };
  });

  worksheet.views = [
      {
          state: 'frozen',
          ySplit: 1
      }
  ];

  worksheet.autoFilter = 'A1:F1';

  workbook.xlsx.writeBuffer().then((data) => {

      let blob = new Blob(
          [data],
          {
              type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
      );

      FileSaver.saveAs(
          blob,
          'AddressableSpendUpload.xlsx'
      );

      this.setState({
          isSaveInProgress: false
      });
  });
} 

handleSubmit = () => {

  console.log(
      'Submit Clicked'
  );

  console.log(
      'Rows In State',
      this.state.excelData.length
  );

  const rowData = this.state.excelData;

  if (!rowData || rowData.length === 0) {

    console.log(
        'excelData is empty at submit'
    );

    console.log(
        this.state
    );

    this.setState({
        responseMsg: 'No records found for upload',
        isError: 'Yes'
    });

    return;
}

  this.setState({
      isLoading: true,
      isSaveInProgress: true
  });

  const recordsToInsert =
    rowData.map(item => ({

      VS_ID:
        this.props.spendDetails.currentActiveRequest.VS_ID,

      DMC_ID:
        this.props.spendDetails.currentActiveRequest.DMC_ID,

      USER_ID:
        this.props.user.user.Email,

        DATA_COLLECTIONS_SKEY:
        item["Skey"],

        ADDRESSABLE_SPEND:
        item["Addressable Spend"],

    SUPPLIER_ID:
        item["Vendor ID"]

    }));


  this.props.saveRecords(recordsToInsert)
      .then(() => {

          this.setState({
              isLoading: false,
              isSaveInProgress: false
          });

          this.props.closePopup();

          this.props.reloadGrid();

      })
      .catch(error => {

          this.setState({
              isLoading: false,
              isSaveInProgress: false,
              responseMsg:
                  error.Message ||
                  'Upload failed',
              isError: 'Yes'
          });

      });
}

    render(){
        return(
            <div style={{padding:'30px'}}>
                            <div>
                                {(this.state.isSaveInProgress) ?
                                    <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                                        src={path + `images/ajax-loader.gif`} alt="" />
                                    : null
                                }
                            </div>

                            {(this.state.isLoading || this.state.isSaveInProgress) && (
  <div style={{ color: 'orange', marginTop: '10px' }}>
    Upload in progress. Please do not close this window.
  </div>
)}
                                   
                <div className="grid-x grid-padding-x">
                    <div className="medium-12 popHeader">Upload Addressable Spend</div>
                    <div className="medium-12 tab-description">1. Download Excel template</div>
                    <div className="medium-12 tab-description">2. Make Edits to the Addressable Spend field only.</div>
                    <div className="medium-12 tab-description">3. Choose your updated template  and click upload</div>                     
                </div>
                <br></br>
                <div className="grid-x grid-padding-x pt10">

                              <div className="medium-4"><ButtonWithoutLoader 
                                type='submit'
                                content={this.props.content.downloadBtn}  
                                onClick={(e)=>this.handleDownload(e)}                              
                                color
                                /></div>

                              <div className="medium-5 pt10" style={{ float: 'right' }}>
                                <input
                                  type="file"
                                  style={{display: 'block'}}
                                  accept='.xlsx, .xls'
                                  id='csvFile'
                                  onChange={(e)=>this.handleChange(e)}                                  
                                />
                              </div>
                              
                              <div className="medium-3" style={{ float: 'left' }}>
                               <ButtonWithoutLoader
                                type='submit'
                                content={this.props.content.uploadBtn}                          
                                color
                                onClick={this.handleSubmit.bind(this)}
                                className={classNames('float-right',
                                                    {
                                                        'hand-cursor': this.state.isLoading ? false : true,
                                                        'gray-scale': this.state.isLoading ? true : false
                                                    })}
                               disabled={
                                                      this.state.isLoading ||
                                                      this.state.excelData.length === 0
                                                  }
                                />
                              </div>

                 </div>
               
                <br></br>
            <div
              className="grid-x grid-padding-x"
              style={{
                color: (this.state.isError === "Yes") ? 'red' : 'green',
                whiteSpace: 'pre-line',
                maxHeight: '200px',
                overflowY: 'auto'
              }}
            >
              {this.state.responseMsg}
            </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
      userData: state.valueStory,
      user: state.default,
      validation: state.content.validation,
      spendDetails: state.spendDetails,
      content: state.content.spendAnalysis.detailedFile
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      uploadUserDefinedFields: (records) => dispatch(uploadUserDefinedFields(records)),
      insertReportLogDetails:(DMC_ID, VS_ID, USER_ID, LOG_TYPE, FILE_NAME) => dispatch(insertReportLogDetails(DMC_ID, VS_ID, USER_ID, LOG_TYPE, FILE_NAME))
    }
  }
  
  export default connect(mapStateToProps,  mapDispatchToProps)(UploadAddressableSpend)